export function applyTasklistPlaceholders(
  text: string,
  vars: { studentName?: string; school?: string; schoolAbbr?: string }
): string {
  let s = text;
  if (vars.studentName !== undefined) {
    s = s.replace(/\{studentName\}/g, vars.studentName);
    s = s.replace(/\{student\}/g, vars.studentName);
  }
  if (vars.school !== undefined) {
    s = s.replace(/\{school\}/g, vars.school);
    /** CMS clubs & workshops copy (school API HTML) uses bracket form. */
    s = s.replace(/\[School Name\]/gi, vars.school);
  }
  if (vars.schoolAbbr !== undefined) {
    s = s.replace(/\{schoolAbbr\}/g, vars.schoolAbbr);
  }
  return s;
}
